const BILLED_UPON_BY_TRIGGER = {
    automatic: [
        'ongoing',
        'approval',
        'oneTimeInStages'
    ],
    manual: [
        'oneTimeManual',
        'oneTimeDelivery',
        'repeatableManual',
        'onDemand'
    ]
};
const triggerOf = (value)=>BILLED_UPON_BY_TRIGGER.automatic.includes(value) ? 'automatic' : 'manual';
const uniqueTriggers = (values)=>[
        ...new Set(values.map(triggerOf))
    ];
const expandTriggers = (triggers)=>triggers.flatMap((trigger)=>[
            ...BILLED_UPON_BY_TRIGGER[trigger]
        ]);
export const billedUponToTrigger = (predicate)=>{
    var _predicate_in;
    return predicate.nin != null ? {
        nin: uniqueTriggers(predicate.nin)
    } : {
        in: uniqueTriggers((_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [])
    };
};
export const triggerToBilledUpon = (predicate)=>{
    var _predicate_in;
    return predicate.nin != null ? {
        nin: expandTriggers(predicate.nin)
    } : {
        in: expandTriggers((_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [])
    };
};
